import { useState, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import "react-datepicker/dist/react-datepicker.css";
import { useForm } from "react-hook-form";
import { IMAGE_URL, BASE_URL, EDIT_DOCTOR } from "../../API";
import Avtar from '../../Assets/Images/Avatar.svg'
import Loader from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";
import { ProfileContext } from "../../context/ProfileContext";

function ViewDoctor() {
  const { headers, getAllDoctors, doctorPagination } = useContext(ProfileContext);
  const location = useLocation();
  const { state } = location || {};
  const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: state });
  const navigate = useNavigate();
  const [viewMode, setViewMode] = useState("view");
  const [isLoading, setIsLoading] = useState(false);
  const [preview, setPreview] = useState(state?.image ? IMAGE_URL + state.image : Avtar);
  const [imageFile, setImageFile] = useState(null);

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("email", data.email || state.email);
      formData.append("specialization", data.specialization);
      formData.append("gmc_number", data.gmc_number);
      formData.append("prescriber_number", data.prescriber_number);

      if (imageFile) {
        formData.append("file", imageFile);
      }

      const response = await axios.patch(BASE_URL + EDIT_DOCTOR, formData, { headers: { ...headers, 'Content-Type': 'multipart/form-data' } });

      if (response.data.code === 200 && response.data.status === true) {
        toast.success(response.data.message);
        getAllDoctors(doctorPagination?.currentPage || 1);
        console.log(2)
        navigate("/doctor-management");
      } else {
        toast.error(response.data.message || "Something went wrong");
      }
    }
    catch (error) { toast.error(error.response?.data?.error_description) }
    finally { setIsLoading(false) }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/doctor-management" }}>Doctor Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >{viewMode === "view" ? "View" : "Edit"} Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>

              <div className="patient_referral_form">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="comm_inner_sub_heading mb-0">{viewMode === "view" ? "View" : "Edit"} Doctor Details</h5>
                  <button type="button" className="main-outline-btn" onClick={() => setViewMode(viewMode === "view" ? "edit" : "view")}>
                    {viewMode === "view" ? "Edit" : "Cancel Edit"}
                  </button>
                </div>
                <div className="comm_border_box">
                  <Form className="comm_form" onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Profile Image</Form.Label>
                          <div className="my-profile-left d-flex employer_logo_edit">
                            <div className="profile-pic">
                              <figure className="profile-img-edit">
                                <img src={preview} alt="Profile Preview" />
                              </figure>
                              {viewMode === "edit" && (
                                <div className="edit-icon">
                                  <input type="file" accept="image/*" onChange={handleImageChange} id="profile-upload" style={{ display: 'none' }} />
                                  <label htmlFor="profile-upload" className="edit-btn text-white bg-primary rounded-circle d-flex align-items-center justify-content-center cursor-pointer" style={{ width: '32px', height: '32px', position: 'absolute', bottom: '0', right: '0', cursor: 'pointer' }}>
                                    <i className="fa fa-camera"></i>
                                  </label>
                                </div>
                              )}
                            </div>
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Name</Form.Label>
                          <Form.Control type="text" placeholder="Enter Name" disabled={viewMode === "view"}
                            {...register("name", { required: 'Please enter name.', validate: value => value.trim() !== "" || "Name cannot be Empty or just spaces.", })}
                          />
                          {errors.name && <span className="error">{errors.name.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Email</Form.Label>
                          <Form.Control type="email" placeholder="Enter Your Email" disabled
                            {...register('email', {
                              required: "Please enter email address",
                              pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: "Invalid email address" }
                            })} />
                          {errors.email && <span className='error'>{errors.email.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Specialization</Form.Label>
                          <Form.Control type="text" disabled={viewMode === "view"} placeholder="Enter Specialization"
                            {...register("specialization", {
                              required: 'Please enter Specializaton.',
                              validate: value => value.trim() !== "" || "Specialization cannot be Empty or just spaces.",
                            })}
                          />
                          {errors.specialization && <span className="error">{errors.specialization.message}</span>}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Registration Number (GMC Number)</Form.Label>
                          <Form.Control type="text" placeholder="Enter GMC Number" disabled={viewMode === "view"}
                            maxLength={7}
                            {...register("gmc_number", {
                              required: "Please enter your GMC Registration Number.",
                              pattern: { value: /^[0-9]{7}$/, message: "GMC Number must be exactly 7 digits." },
                            })}
                          />
                          {errors.gmc_number && (
                            <span className="error">{errors.gmc_number.message}</span>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="comn-class-inputs">
                          <Form.Label>Prescriber Number</Form.Label>
                          <Form.Control type="text" placeholder="Enter Prescriber Number" disabled={viewMode === "view"}
                            {...register("prescriber_number", {
                              required: "Please enter your Prescriber Number.",
                              pattern: {
                                value: /^[A-Za-z0-9\-\/]+$/,
                                message: "Prescriber Number can only contain letters, numbers, hyphens or slashes."
                              },
                            })}
                          />
                          {errors.prescriber_number && (<span className="error">{errors.prescriber_number.message}</span>)}
                        </Form.Group>
                      </Col>
                    </Row>
                    {viewMode === "edit" ? (
                      <div className="modal_pair_btns patient_referral_btns mt-3">
                        <button className='main-btn' type="submit">Submit</button>
                        <button type="button" className='main-outline-btn' onClick={() => setViewMode("view")}>Cancel</button>
                      </div>
                    ) : (
                      <div className="modal_pair_btns patient_referral_btns mt-3">
                        <button type="button" className='main-outline-btn' onClick={() => navigate('/doctor-management')}>Go Back</button>
                      </div>
                    )}
                  </Form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewDoctor;
